export const RECENT_ITEMS_KEY = "dsa5_recent_items"
const MAX_RECENT = 8

export function getRecentItems(storage = localStorage) {
  try {
    return JSON.parse(storage.getItem(RECENT_ITEMS_KEY) || "[]")
  } catch {
    return []
  }
}

export function saveRecentItem(item, storage = localStorage) {
  if (!item?.id) return

  const entry = {
    id: item.id,
    name: item.name,
    type: item.type,
    type_label: item.type_label,
    icon: item.icon,
    url: item.url,
    book: item.book,
    status: item.status,
    status_label: item.status_label,
    viewed_at: item.viewed_at || new Date().toISOString(),
  }

  let recent = getRecentItems(storage).filter((r) => r.id !== entry.id)
  recent = [entry, ...recent].slice(0, MAX_RECENT)

  try {
    storage.setItem(RECENT_ITEMS_KEY, JSON.stringify(recent))
  } catch {
    // localStorage might be unavailable
  }
}

export function mergeRecentItems(serverItems, localItems) {
  const byId = new Map()

  ;[...localItems, ...serverItems].forEach((item) => {
    const existing = byId.get(item.id)
    if (!existing) {
      byId.set(item.id, item)
      return
    }

    const existingTime = Date.parse(existing.viewed_at || 0)
    const itemTime = Date.parse(item.viewed_at || 0)
    byId.set(item.id, itemTime >= existingTime ? { ...existing, ...item } : { ...item, ...existing })
  })

  return Array.from(byId.values())
    .sort((a, b) => Date.parse(b.viewed_at || 0) - Date.parse(a.viewed_at || 0))
    .slice(0, MAX_RECENT)
}
